// extracted by mini-css-extract-plugin
module.exports = {"user":"viewUser_user__fOx57","selectedUser":"viewUser_selectedUser__14gJo","description":"viewUser_description__LLFX0"};